import { j as r } from "../accordion/Accordion-CrPiD_81.mjs";
const n = (s) => {
  switch (s) {
    case "error":
      return { "--mark-color": "var(--rds-feedback-error-dark)" };
    case "success":
      return { "--mark-color": "var(--rds-feedback-success)" };
    case "faded":
      return { "--mark-color": "var(--rds-foreground-secondary)" };
    default:
      return;
  }
}, u = ({
  className: s = "",
  children: e,
  innerClassName: a = "",
  icon: c,
  testId: t = "rds-list-item",
  style: o,
  color: l,
  ...d
}) => {
  const i = {
    ...o,
    ...n(l)
  };
  return /* @__PURE__ */ r.jsxs("li", { className: `rds-list__item ${s}`, "data-testid": t, style: i, ...d, children: [
    /* @__PURE__ */ r.jsx("span", { className: "rds-list__item--svg-wrapper", children: c || /* @__PURE__ */ r.jsx("svg", { viewBox: "0 0 24 24", children: /* @__PURE__ */ r.jsx("circle", { cx: "12", cy: "12", r: "5", fill: "currentColor" }) }) }),
    /* @__PURE__ */ r.jsx("span", { className: `${a}`, children: e })
  ] });
};
export {
  u as L
};
